__turbopack_context__.v({
  "page-body-wrap": "S9mFva_page-body-wrap",
  "paragraph-content": "S9mFva_paragraph-content",
  "wrap-container": "S9mFva_wrap-container",
  "wrap-content": "S9mFva_wrap-content",
});
